<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<v-data-table
		:headers="headers"
		:rows-per-page-items="[10,20,25]"
		:items="projects"
		:pagination.sync="pagination"
		:total-items="itemCount"
		class="elevation-1 ma-4">
		<template v-slot:items="props">
			<td>{{ props.item.projectCode }}</td>
			<td>{{ props.item.projectTitle }}</td>
			<td>{{ props.item.contestName }}</td>
			<td>{{ props.item.bidderName }}</td>
			<td>{{ printAllCountries(props.item) }}</td>
			<td>
				<v-tooltip bottom>
					<template v-slot:activator="{ on }">
						<v-btn icon v-if="!props.item.hideFromUser"
							@click="goToProjectPanel(props.item)">
							<v-icon v-on="on">
								business
							</v-icon>
						</v-btn>
					</template>
					<span>Panel projektu</span>
				</v-tooltip>
				<v-tooltip bottom>
					<template v-slot:activator="{ on }">
						<v-btn icon v-if="!props.item.hideFromUser"
							@click="showProject(props.item)">
							<v-icon v-on="on">
								description
							</v-icon>
						</v-btn>
					</template>
					<span>Podgląd</span>
				</v-tooltip>
				<v-tooltip bottom>
					<template v-slot:activator="{ on }">
						<v-btn icon v-if="!props.item.hideFromUser"
							@click="projectSummary(props.item)">
							<v-icon small v-on="on">
								ballot
							</v-icon>
						</v-btn>
					</template>
					<span>Podsumowanie projektu</span>
				</v-tooltip>
			</td>
		</template>
	</v-data-table>
</template>

<script>
	import {Api} from "../../../../../api";

	export default {
		name: "SupervisedProjectsTable",

		data () {
			return {
				headers: [
					{text: "Nr projektu", value: "projectCode", align: "left", sortable: true},
					{text: "Nazwa projektu", value: "projectTitle", sortable: true},
					{text: "Nazwa konkursu", value: "contestName", sortable: true},
					{text: "Nazwa oferenta", value: "bidderName", sortable: true},
					{text: "Kraje projektu", value: "country", sortable: true},
					{text: "Akcje", value: "action", sortable: false}
				],
				projects: [],
				itemCount: 0,
				pagination: {
					rowsPerPage: 25,
					sortBy: null
				},
			};
		},

		watch: {
			"pagination": {
				handler () {
					this.getItemList();
				},
				deep: true
			},
		},

		methods: {
			buildSort () {
				let order = this.pagination.descending ? "desc" : "asc";
				let columnName = this.pagination.sortBy;
				if (order && columnName) {
					return columnName.concat(" ").concat(order);
				} else {
					return "";
				}
			},

			getItemList () {
				let sort = this.buildSort();
				Api.get(this,
					"/supervised-projects/list?search=userId::" + this.$route.params.userId + '$$'
						+ "&page=" + this.pagination.page
						+ "&result=" + this.pagination.rowsPerPage
						+ "&sort=".concat(sort), response => {
							this.projects = response.itemList;
							this.itemCount = response.itemCount;
						});
			},

			showProject (project) {
				this.$router.openInNewTab("/view/project/".concat(project.id));
			},

			projectSummary (project) {
				this.$router.push("/app/project/" + project.id + "/summary");
			},

			goToProjectPanel (project) {
				this.$router.push("/app/".concat(project.contestId).concat("/project-panel/").concat(project.id));
			},

			printAllCountries (project) {
				let output = project.country;
				project.extraCountries.forEach(country => output = output + ', ' + country);
				return output;
			}
		}
	};
</script>

<style scoped>

</style>
